<div class="mt-2">
	<app-customer-lookup (customer_selected)="selectCustomer($event)"></app-customer-lookup>
</div>
